
咨询页面
<template>
  <div class="completedCon">
    <!-- 下部内容 -->
    <div class="contentList">
      <el-table
        :data=tableData
        class="el-table"
        :stripe=true
        :border=true
        :height="600"
        :default-sort = "{prop: 'date', order: 'descending'}">
        <!-- 日期 -->
        <el-table-column
          label="日期"
          prop="time"
          sortable
        >
        </el-table-column>
        <!-- 姓名 -->
        <el-table-column
          label="姓名"
          prop="name"
        >
        </el-table-column>
        <!-- 联系方式 -->
        <el-table-column
          label="联系方式"
          prop="phone"
        >
        </el-table-column>
        <!-- 公司名 -->
        <el-table-column
          label="公司名"
          prop="company"
        >
        </el-table-column>
        <!-- 管控品牌 -->
        <el-table-column
          label="管控品牌"
          prop="brand"
        >
        </el-table-column>
        <!-- 行业 -->
        <el-table-column
          label="行业"
          prop="industry"
        >
        </el-table-column>
        <!-- 咨询内容 -->
        <el-table-column
          label="咨询内容"
          prop="demand"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          align="center"
          label="操作"
          >
          <template slot-scope="scope">
            
            <el-button
              size="small"
              type="danger"
              @click="deleteHandle(scope.row.id)">删除信息</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import api from '@/api'
export default {
  data() {
        return {
           tableData: [],//信息
            search: '',

        }
  },

  created(){
    this.getDataList()
  },

  methods: {
    
    //弹框  删除
    deleteHandle(id) {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
                  type: 'success',
                  message: '不给删'
                });
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },

    //获取资讯信息
    getDataList(){
      api.getConsultData()
      .then(res =>{
        // console.log(res)
        let consultDataArr = res.data.data.list
        // console.log(consultDataArr)

        consultDataArr.forEach(el => {
            let consultData = {
              id:el.id,
              company:el.company,
              demand:el.demand,//咨询内容
              brand:el.brand,//所需管控品牌
              name:el.name,
              phone:el.phone,
              time:el.time,
            }
            if(el.industry) {
              consultData.industry = el.industry
            }

            this.tableData.push(consultData)
        });

        // console.log(this.tableData)
      })
    }

     
    
  },
    
}
</script>

<style scoped lang="scss">
    .completedCon{
        width: 100%;
        background: rgb(235, 235, 235);
        overflow: hidden;

        .contentList{
          margin:20px auto;
          padding:0 10px;
          overflow-y: auto;
          padding-bottom: 50px;
        }
        
    }
</style>